import { z } from 'zod';
import { PinComponentSchema } from '../pin-component';
import { LayoutPartSchema } from '../pin-component/layout-part';
import { BasePinSchema, BasePinSettingsSchema, BaseTemplateLayoutSchema } from './base-pin';
import { BaseTeacherPinSettingsSchema } from './base-teacher-pin';

export const SlidePinLayoutKeySettingsSchema = z.enum([
  'BLANK',
  'COVER',
  'IMAGE_ONLY',
  'IMAGE_TOP',
  'IMAGE_LEFT',
  'IMAGE_RIGHT',
  'TITLE_TOP_WITH_BODYTEXT',
  'BODYTEXT_AND_IMAGE_TWO_COLUMNS',
  'BODYTEXT_TWO_COLUMNS',
  'VIDEO_ONLY',
]);
export type SlidePinLayoutKey = z.infer<typeof SlidePinLayoutKeySettingsSchema>;

export const SlideLayoutPartKeySchema = LayoutPartSchema.extract([
  'TITLE',
  'SUBTITLE1',
  'SUBTITLE2',
  'BODYTEXT1',
  'BODYTEXT2',
  'IMAGE1',
  'IMAGE2',
  'VIDEO',
]);
export type SlideLayoutPartKey = z.infer<typeof SlideLayoutPartKeySchema>;

export const SlidePinLayoutTemplateSchema = BaseTemplateLayoutSchema.extend(
  z.object({
    key: SlidePinLayoutKeySettingsSchema,
    layoutParts: z.partialRecord(SlideLayoutPartKeySchema, PinComponentSchema.optional()),
  }).shape
);
export type SlidePinLayoutTemplate = z.infer<typeof SlidePinLayoutTemplateSchema>;

export const SlidePinSettingsSchema = BasePinSettingsSchema.extend(
  z.object({
    layout: SlidePinLayoutKeySettingsSchema,
    layoutParts: z.partialRecord(SlideLayoutPartKeySchema, z.string().optional()),
  }).shape
);

export type SlidePinSettings = z.infer<typeof SlidePinSettingsSchema>;

export const SlideTeacherPinSettingsSchema = BaseTeacherPinSettingsSchema.extend(z.object({}).shape);

export type SlideTeacherPinSettings = z.infer<typeof SlideTeacherPinSettingsSchema>;

export const SlideStudentPinSettingsSchema = z.object({});

export type SlideStudentPinSettings = z.infer<typeof SlideStudentPinSettingsSchema>;

export const SlidePinTypeSchema = z.literal('SLIDE');

export const SlidePinSchema = BasePinSchema.extend(
  z.object({
    type: SlidePinTypeSchema,
    settings: SlidePinSettingsSchema,
  }).shape
);

export type SlidePin = z.infer<typeof SlidePinSchema>;
